import styled from 'styled-components';

export const MobileAppPageContainer = styled.div`
  text-align: center;
  width: 100%;
`;

export const MobileAppHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem 1rem 2rem;
  .logo-image {
    width: 9.8125rem;
    height: 1.530625rem;
    display: inline-block;
  }
  button {
    font-weight: 700;
    font-size: 0.75rem;
    line-height: 1.02125rem;
    padding: 0;
    margin: 0;
    margin-left: auto;
    text-transform: uppercase;
  }
`;
